/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : PAYMENT INFO: STYLES --------------- ++++++++++ */
export default theme =>({
  paymentinfo: {
    padding: pxToEm(32),
    minHeight: pxToEm(320),
    '& .name-formaction': {
      display: 'flex',
      justifyContent: 'space-between',
      margin: `${pxToEm(16)} 0`,
      '& .name-edit': {
        maxWidth: 'initial',
        width: 'auto'
      },
      '& .name-save': {
        width: pxToEm(130)
      },
      '& .name-back': {
        maxWidth: pxToEm(150)
      },
      '& .button': {
        '&:last-child': {
          marginLeft: pxToEm(10)
        }
      }
      
    },
    '& .fileuploader': {
      display: 'flex',
      alignItems: 'center',
      margin: `${pxToEm(8)} 0`,
      '& .button': { height: pxToEm(48) },
      '& .filepreview': { marginTop: 0 }
    },
    '& .name-downloadnotifmsg': {
      marginBottom: `${pxToEm(24)} !important`
    }
  }
});
